module.exports = __webpack_public_path__ + "static/img/garden-steps-2026.2b067c8.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/garden-steps-2026.webp
// module id = 6weH
// module chunks = 0